import {
  GetSaleProductsPreviewQuery,
  GetSaleProductsPreviewQueryVariables,
  useGetSaleProductsPreviewQuery,
} from '@/lib/graphql/generated/graphql';
import { QueryHookOptions } from '@apollo/client';

export const useSaleProductsPreview = (
  brandId: string,
  saleId: string,
  options?: Omit<
    QueryHookOptions<
      GetSaleProductsPreviewQuery,
      GetSaleProductsPreviewQueryVariables
    >,
    'variables'
  >
) => {
  const { data, loading, error } = useGetSaleProductsPreviewQuery({
    variables: { brandId, saleId },
    skip: !brandId || !saleId,
    ...(options ?? {}),
  });

  return {
    products: data?.saleProductsPreview || [],
    loading,
    error,
  };
};
